import { captureEvent } from '../metrics/captureEvent'

/**
 * Captures form submitted
 *
 * @param {string} [event] - event name, for pages that report under their own
 */
export function captureSubmitEvent(event = 'form-submitted') {
  captureEvent(event)
}
